import { render, staticRenderFns } from "./Videos.vue?vue&type=template&id=8388f138&scoped=true"
import script from "./Videos.vue?vue&type=script&lang=js"
export * from "./Videos.vue?vue&type=script&lang=js"
import style0 from "./Videos.vue?vue&type=style&index=0&id=8388f138&prod&lang=scss"
import style1 from "./Videos.vue?vue&type=style&index=1&id=8388f138&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8388f138",
  null
  
)

export default component.exports